<template>
  <div class="auth-page">
    <div class="auth-page__wrapper">
      <div class="auth-block">
        <div class="auth-block__logo">
          <img
            class="auth-block__logo__image"
            :src="require(`@/assets/images/logo_${$config.styleName}.svg`)"
            alt="logo"
            width="121"
            height="93"
          >
          <span class="auth-block__logo__title">SUPPLIER PORTAL</span>
        </div>
        <slot />
        <locale-switch class="mx-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import LocaleSwitch from '@/components/common/LocaleSwitch.vue';

export default {
  name: 'AuthWrapper',
  components: {
    LocaleSwitch,
  },
};
</script>
